import React from 'react'
import { Button, Alert, Popconfirm, Space } from 'antd'

import {
  CloseOutlined,
  CheckOutlined,
  MinusOutlined,
  UndoOutlined
} from '@ant-design/icons'

import { useSatisfactionStatus } from '../../../../../hooks/manager/job'

const Satisfaction = (props) => {
  const { job } = props
  const { mutate: updateSatisfaction, isLoading: actionLoading } = useSatisfactionStatus(job.id)
  const displaySatisfactionAlert = job.status === 'Delivered' && job.satisfaction_type === 'External'
 
  const satisfactionNA = () => updateSatisfaction({ status: 'N/A' })
  const satisfactionDismiss = () => updateSatisfaction({ status: 'DISMISSED' })
  const satisfactionSend = () => updateSatisfaction({ status: 'SENT' })
  const satisfactionUndo = () => updateSatisfaction({ status: null })

  if (!displaySatisfactionAlert) {
    return null
  }

  if (job.satisfaction_status === undefined) {
    return (
      <Alert
        type='info'
        message='Has the customer satisfaction survey been sent?'
        description={' '}
        banner
        showIcon
        action={
          <Space.Compact block size='small'>
            <Popconfirm
              title='Are you sure?'
              onConfirm={satisfactionNA}
              okText='Yes'
              cancelText='No'
              disabled={actionLoading}
            >
              <Button
                size='small'
                icon={<MinusOutlined />}
                disabled={actionLoading}
              >
                N/A
              </Button>
            </Popconfirm>
  
            <Popconfirm
              title='Are you sure?'
              onConfirm={satisfactionDismiss}
              okText='Yes'
              cancelText='No'
              disabled={actionLoading}
            >
              <Button
                size='small'
                icon={<CloseOutlined />}
                disabled={actionLoading}
              >
                Dismiss
              </Button>
            </Popconfirm>
            <Popconfirm
              title='Are you sure?'
              onConfirm={satisfactionSend}
              okText='Yes'
              cancelText='No'
              disabled={actionLoading}
            >
              <Button
                size='small'
                type='primary'
                icon={<CheckOutlined />}
                disabled={actionLoading}
              >
                Yes
              </Button>
            </Popconfirm>
          </Space.Compact>
  
        }
      />
    )
  }

  let message = ''
  if (job.satisfaction_status === 'N/A') {
    message = `The satisfaction survey does not apply to this job.`
  }

  if (job.satisfaction_status === 'SENT') {
    message = `Satisfaction survey status was sent.`
  }

  if (job.satisfaction_status === 'DISMISSED') {
    message = `Satisfaction survey status was dismissed.`
  }

  return (
    <Alert
      type='info'
      message={message}
      description={' '}
      banner
      showIcon
      action={
        <Space.Compact block size='small'>
          <Popconfirm
            title='Are you sure?'
            onConfirm={satisfactionUndo}
            okText='Yes'
            cancelText='No'
            disabled={actionLoading}
          >
            <Button
              size='small'
              type='dashed'
              icon={<UndoOutlined />}
              disabled={actionLoading}
            >
              Revert
            </Button>
          </Popconfirm>
        </Space.Compact>

      }
    />
  )


}

export default Satisfaction
